if(jQuery("div").hasClass("table-type-simple")) {
  jQuery("table").addClass("usa-table--borderless");
}
if(jQuery("div").hasClass("turn-off-mobile-table-on")) {
  jQuery("div.turn-off-mobile-table-on table").removeClass("tablesaw tablesaw-stack");
}
